import styled from "styled-components";
import { COLORS } from "styles/colors";

export const WrapperStyle: React.CSSProperties = {
  position: "relative",
  overflow: "hidden",
};

export const SwiperButton = styled.button<{ next?: boolean }>`
  position: absolute;
  top: 0;
  ${({ next }) => (next ? "right: -4px;" : "left: -4px;")}
  color: ${({ theme }) =>
    theme.value === "light" ? COLORS.BLACK : COLORS.WHITE};
  height: 100%;
`;

export const SwiperList = styled.div<{
  isDragging: boolean;
  currentTranslate: number;
  maxTranslate: number;
}>`
  display: flex;
  transition: ${({ isDragging }) =>
    isDragging ? "none" : "transform 0.3s ease-out"};
  transform: translateX(
    ${({ currentTranslate, maxTranslate }) =>
      currentTranslate > maxTranslate ? currentTranslate : maxTranslate}px
  );
  gap: 12px;
  cursor: ${({ isDragging }) => (isDragging ? "grabbing" : "grab")};
  width: fit-content;
  user-select: ${({ isDragging }) => (isDragging ? "none" : "auto")};
`;

export const DragTrack = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  cursor: grabbing;
  z-index: 1000;
`;
